import {
  ImageScaleView,
  MaskView,
  MaskViewOpts,
} from '@play-co/timestep-core/ui';

interface TilingBackgroundOptions {
  maskOpts: MaskViewOpts;
  tileOpts: { image: string } & ({ columns: number } | { rows: number });
  movementOpts?: {
    speed?: number;
    direction: 'horizontal' | 'vertical' | 'diagonal';
  };
}

export default class TilingBackground extends MaskView {
  private background: ImageScaleView;
  private tx = 0;
  private ty = 0;
  private dx = 0;
  private dy = 0;

  constructor(opts: TilingBackgroundOptions) {
    super({
      ...opts.maskOpts,
      mask: opts.maskOpts.mask ?? 'assets/ui/match2/team/mask_default.png',
    });
    const baseWidth = opts.maskOpts.width ?? 100;
    const baseHeight = opts.maskOpts.height ?? 100;
    const baseColumns = (opts.tileOpts as { columns: number }).columns;
    const baseRows = (opts.tileOpts as { rows: number }).rows;

    const animateDiagonally = opts.movementOpts?.direction === 'diagonal';
    const animateHorizontally =
      animateDiagonally || opts.movementOpts?.direction === 'horizontal';
    const animateVertically =
      animateDiagonally || opts.movementOpts?.direction === 'vertical';

    const maxSize = Math.max(baseWidth, baseHeight);
    const targetSize = animateHorizontally ? baseWidth : baseHeight;
    const size = animateDiagonally ? maxSize : targetSize;
    const width = size * (animateHorizontally ? 2 : 1);
    const height = size * (animateVertically ? 2 : 1);
    const columns = baseColumns
      ? baseColumns * (animateHorizontally ? 2 : 1)
      : undefined;
    const rows = baseRows ? baseRows * (animateVertically ? 2 : 1) : undefined;

    this.background = new ImageScaleView({
      ...opts.tileOpts,
      superview: this,
      width,
      height,
      scaleMethod: 'tile',
      columns,
      rows,
    });

    if (opts.movementOpts) {
      const speed = opts.movementOpts.speed ?? 1;
      const d = 15 * speed;
      this.dx = animateHorizontally ? d : 0;
      this.dy = animateVertically ? d : 0;
    }
  }

  public tick(dt: number): void {
    if (this.dx) {
      const width = this.background.style.width * 0.5;
      this.tx += this.dx * dt * 0.001;
      this.tx = ((this.tx % width) + width) % width;
      this.tx -= width;
      this.background.style.x = Math.round(this.tx);
    }

    if (this.dy) {
      const height = this.background.style.height * 0.5;
      this.ty += this.dy * dt * 0.001;
      this.ty = ((this.ty % height) + height) % height;
      this.ty -= height;
      this.background.style.y = Math.round(this.ty);
    }
  }
}
